

export default {
    // getFilteredSubKategori : (state) => (id) => state.subKategoriSOSList.filter(v => v.kategori.id === id),
    // getFilteredSyarat: state => id => state.syaratList.filter(v => v.kategori.id == id)
}
